import type { Components, Theme } from "@mui/material";

export const alertTitleTheme: Components<Theme>["MuiAlertTitle"] = {
  styleOverrides: {
    root: () => ({
      fontWeight: 600,
    }),
  },
};
